import { Component, EventEmitter, Input, OnInit, Output, inject } from "@angular/core";
import { FormBuilder, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { ProductItemGroup } from "@domain/project/floorplan/product-item-group";
import { SwitchComponent } from "@odx/angular/components/switch";
import { FloorplanService } from "@project/floorplanner/floorplan.service";

@Component({
  selector: "app-toggle-group-visibility-button",
  standalone: true,
  imports: [SwitchComponent, ReactiveFormsModule],
  templateUrl: "./toggle-group-visibility-button.component.html",
  styleUrl: "./toggle-group-visibility-button.component.scss",
})
export class ToggleGroupVisibilityButtonComponent implements OnInit {
  private formBuilder = inject(FormBuilder);
  private floorplanService = inject(FloorplanService);

  @Input() group!: ProductItemGroup;
  @Input() isSelected: boolean = false;
  @Output() toggled = new EventEmitter<string>();

  protected showGroupVisibilityForm!: FormGroup;
  protected selected: boolean | undefined;

  ngOnInit(): void {
    this.initForm();
  }

  private initForm() {
    this.showGroupVisibilityForm = this.formBuilder.group({
      showGroupVisibility: [this.isSelected],
    });
    this.showGroupVisibilityForm.valueChanges.subscribe((value) => {
      if (!this.showGroupVisibilityForm.valid || this.showGroupVisibilityForm.pristine) return;
      if (value.showGroupVisibility) {
        this.floorplanService.selectedFloorplan.floorplanState.selectGroup(this.group); //selectedGroupId = this.group.id;
      } else {
        this.floorplanService.selectedFloorplan.floorplanState.deselectGroup(this.group);
      }
    });
  }
}
